/**
 * Who can open the Admin hub and edit the Team Roster (Oct 19, 2026).
 *
 * Greg: "add the admin board/page to shannon's profile so she can see the team
 * roster", then "shannon can edit the roster". Finance (Shannon) edits the
 * roster like leadership: add, edit (commission rates included), leave,
 * offboard, reactivate. The database admits finance on every gate behind those
 * actions (supabase/migrations/20261019g_team_roster_finance_edit.sql: the
 * tr_leadership_* and trc_* policies, tra_read and team_roster_guard_sensitive),
 * and the send-email edge function admits finance for the IC signing link.
 * Change these together.
 *
 * The rest of the Admin hub (Team Boards, Hover, QuickBooks, Google Calendar)
 * stays leadership-only: those routes and cards refuse finance.
 *
 * Keyed on the PRIMARY role, like get_my_role(): a secondary_role grants no
 * roster rights. Super users resolve to admin server-side.
 */

export const LEADERSHIP_ROLES: ReadonlySet<string> = new Set(["admin", "sales_director", "director_of_operations"]);

export const ROSTER_EDITOR_ROLES: ReadonlySet<string> = new Set([...LEADERSHIP_ROLES, "finance"]);

export function isLeadership(role: string | null | undefined, isSuperUser: boolean): boolean {
  return isSuperUser || (!!role && LEADERSHIP_ROLES.has(role));
}

export function canEditRoster(role: string | null | undefined, isSuperUser: boolean): boolean {
  return isSuperUser || (!!role && ROSTER_EDITOR_ROLES.has(role));
}
